import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { PRODUCTS_PATH } from '../../core/constants';

export const getProductsFromProductAvailabilityForDocumentAction = createAsyncThunk(
    'product/getProductsFromProductAvailabilityForDocumentAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PRODUCTS_PATH }/document/product-availability${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductsFromProductAvailabilityForDocumentSlice = createSlice({
    name: 'getProductsFromProductAvailabilityForDocumentSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getProductsFromProductAvailabilityForDocumentAction.pending, () => STATE__API__STARTED);
        builder.addCase(getProductsFromProductAvailabilityForDocumentAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductsFromProductAvailabilityForDocumentAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getProductsFromProductAvailabilityForDocumentState = (state) => state.product.getProductsFromProductAvailabilityForDocument;
export default getProductsFromProductAvailabilityForDocumentSlice.reducer;
